<template>
        <div>
            <form class="form-inline" @submit.prevent="saveDiagnosis">
                <label class="mr-sm-2" for="disease">Diagnóza</label>
                <div class="col-md-4">
                    <multiselect ref="addDiagnosisSearchInput" v-model="selected" id="search" label="label" track-by="code" placeholder="vyhledat diagnózu" :options="diseases" :multiple="false" :searchable="true" :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getDiseases" @select="selectDisease" selectLabel="" data-testid="visit-diagnosis-search"></multiselect>
                </div>
                <label for="note" class="ml-sm-2 mr-sm-2">Poznámka</label>
                <input v-model="diagnosis.note" type="text" class="form-control form-control-sm mr-sm-2" aria-describedby="operationHelp" id="note" data-testid="visit-diagnosis-note">
                <button type="submit" class="btn btn-sm btn-success" id="addDiagnosisButton" data-testid="visit-diagnosis-add">Přidat diagnózu</button>
                <!-- <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>-->
            </form>
        </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'
  import apiMixin from '@/mixins'

  // import Modal from './ConfirmVisitModal.vue'

  export default {
    data () {
      return {
        selected: '',
        fromSearch: '',
        // Diagnosis (post)
        diagnosis: {},
        diagnosisPending: false,
        diagnosisError: false,
        diagnosisDone: false,
        // Diseases
        diseases: [],
        diseasesPending: false,
        diseasesError: false
      }
    },
    /* computed: mapState({
      // diseases: state => state.diseases,
      // diseasesError: state => state.error.diseases,
      // diseasesPending: state => state.pending.diseases,
      // diagnosis: state => state.diagnosis,
      // diagnosisError: state => state.error.diagnosis
      // diagnosisPending: state => state.pending.diagnosis
    }), */
    mixins: [apiMixin],
    props: ['focusInput'],
    methods: {
      // ...mapActions(['searchDisease']),
      saveDiagnosis () {
        this.postDiagnosis(this.$route.params.visitid, this.diagnosis)
        // this.postDiagnosis({params: {visitId: this.$route.params.visitid}, data: this.diagnosis})
        /* this.diagnosisPending = true
        this.$http.post('/visit/' + this.$route.params.visitid + '/diagnosis', this.diagnosis, {emulateJSON: true}).then(response => {
          this.diagnosisPending = false
          this.diagnosisAdded()
        }, response => {
          this.errors = response.body.errors
          this.diagnosisPending = false
        }) */
      },
      /* getDiseases (search) {
        this.diseasesPending = true
        this.get_params.search = search
        this.$http.get('/icd/disease', {params: this.get_params}).then(response => {
          this.diseases = response.data
          this.diseasesPending = false
        }, response => {
          this.diseasesPending = false
        })
        // this.searchDisease({params: {search: search}})
      }, */
      selectDisease (val) {
        this.diagnosis.disease = val.code
        document.getElementById('addDiagnosisButton').focus()
      }
    },
    beforeMount () {
    },
    watch: {
      focusInput (val) {
        if (val === true) {
          this.$refs.addDiagnosisSearchInput.$el.focus()
        }
      },
      diagnosisDone (val) {
        this.diagnosis = {}
        if (val === true) {
          this.$emit('update')
          this.diagnosisDone = false
          this.diseases = []
          this.selected = ''
        }
      }
    },
    components: {}
    /* watch: {
      visit: function (val) {
        this.visit.operation = val + ' ' + this.lastName
      }
    } */
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    table.table_calendar > thead > tr > th {
        margin: 0;
        padding: 0;
        font-size: x-small;
        border: none;
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:last-of-type {
        border-right: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:first-of-type {
        border: none;
    }

    table.table_calendar > thead > tr > th.halfHour {
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th.sixth_cell {
        border-right: 1px solid #888;
        background-color: dodgerblue;
    }

    table.table_calendar > tbody > tr > td {
        margin: 0;
        padding: 0;
        border: none;
        border-bottom: 1px solid #888;
        border-right: 1px solid #888;
    }

    table.table_day {
        margin: 0;
    }
    table.table_day td {
        padding: 0;
        margin: 0;
        border: none;
        border-right: 1px dotted black;
        padding: 10px 0 10px 0;
    }

    table.table_day td:last-of-type{
        border-right: none;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .table > tbody > tr > td, .table > tfoot > tr > td {
        vertical-align: middle;
    }

    td.selected {
        background-color: deeppink;
    }

    .highlight_hovered tr:hover {
        background-color: #ffa;
    }

    .visit {
        background-color: orange;
        opacity: 0.5;
    }

    .visit-multi {
        background-color: orangered;
        opacity: 0.5;
    }

    .unoccupied{
        background-color: greenyellow;
        opacity: 0.5;
    }

    .hovered_window {
        opacity: 0.9;
    }

    .selected_window {
        background-color: green;
    }

    .hovered_window.visit {
        background-color: orangered;
    }

    .selected_window.visit {
        background-color: red;
    }

    td.hourly {
        border-right: 1px solid black !important;
    }

    td.halfhourly {
        border-right: 1px solid #444 !important;
    }

    td:hover {
        opacity: 0.8;
        cursor:crosshair
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Visit/components/AddDiagnosis.vue?2a41b9f6